<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="900px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              
              <div class="col-md-6">
                <v-menu
                  ref="scheduled_date_menu"
                  v-model="scheduled_date_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.scheduled_date"
                      label="Fecha Programada*"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-validate="'required'"
                      name="scheduled_date"
                      data-vv-as="Fecha Programada"
                      :disabled="isViewModal()"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.scheduled_date" no-title scrollable @input="scheduled_date_menu = false"></v-date-picker>
                </v-menu>
                <span class="red--text">{{ errors.first("scheduled_date") }}</span>

                     <v-menu
                  ref="estimated_end_date_menu"
                  v-model="estimated_end_date_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.estimated_end_date"
                      label="Fecha Estimada de Fin*"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-validate="'required'"
                      name="estimated_end_date"
                      data-vv-as="Fecha Estimada de Fin"
                      :disabled="isViewModal()"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.estimated_end_date" no-title scrollable @input="estimated_end_date_menu = false"></v-date-picker>
                </v-menu>
                <span class="red--text">{{ errors.first("estimated_end_date") }}</span>

                <v-combobox
                  v-model="item.warehouse_origen"
                  data-vv-as="Almacén Origen"
                  name="warehouse_origen"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  label="Almacén Origen*"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("warehouse_origen") }}</span>
                <v-combobox
                  v-model="item.warehouse_destino"
                  data-vv-as="Almacén Destino"
                  name="warehouse_destino"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  label="Almacén Destino*"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("warehouse_destino") }}</span>

                <v-combobox
                  v-model="item.formula"
                  data-vv-as="Fórmula"
                  name="formula"
                  item-text="name"
                  item-value="id"
                  :items="formulas"
                  label="Fórmula*"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal() || isInExecution"
                  @change="calculateQuantityProductFinal"
                ></v-combobox>
                <span class="red--text">{{ errors.first("formula") }}</span>
              </div>

        

              <div class="col-md-6">
                <v-text-field
                  data-vv-as="Cantidad"
                  label="Cantidad de formula a producir*"
                  name="quantity"
                  type="number"
                  v-model="item.quantity"
                  v-validate="'required|decimal|min_value:1'"
                  :disabled="isViewModal() || isInExecution"
                  @input="calculateQuantityProductFinal"
                  min="1"
                ></v-text-field>
                <span class="red--text">{{ errors.first("quantity") }}</span>

                <v-text-field
                  data-vv-as="Cantidad Producto Final"
                  label="Cantidad Producto Final"
                  name="quantity_product_final"
                  type="number"
                  v-model="item.quantity_product_final"
                  disabled
                  hint="Se calcula automáticamente: Cantidad × Fórmula"
                  persistent-hint
                ></v-text-field>
       
                <v-combobox
                  v-model="item.line_production"
                  data-vv-as="Línea de Producción"
                  name="line_production"
                  item-text="name"
                  item-value="id"
                  :items="lines_production"
                  label="Línea de Producción"
                  :disabled="isViewModal()"
                  clearable
                ></v-combobox>
       
                <v-combobox
                  v-model="item.internal_state"
                  data-vv-as="Estado Interno"
                  name="internal_state"
                  item-text="name"
                  item-value="id"
                  :items="internal_states"
                  label="Estado Interno"
                  :disabled="isViewModal()"
                  clearable
                ></v-combobox>

                <v-combobox
                  v-model="item.user_assignated"
                  data-vv-as="Usuario Asignado"
                  name="user_assignated"
                  item-text="business_name"
                  item-value="id"
                  :items="users"
                  label="Usuario Asignado"
                  :disabled="isViewModal()"
                  clearable
                ></v-combobox>
              </div>


              <div class="col-md-12">
                <v-text-field
                  data-vv-as="Referencia Externa"
                  label="Referencia Externa"
                  name="external_reference"
                  v-model="item.external_reference"
                  :disabled="isViewModal()"
                  hint="Número de referencia externa (opcional)"
                  persistent-hint
                ></v-text-field>
              </div>

              <div class="col-md-12">
                <v-textarea
                  data-vv-as="Observaciones"
                  label="Observaciones"
                  name="observations"
                  v-model="item.observations"
                  rows="3"
                  :disabled="isViewModal()"
                ></v-textarea>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { generalService } from "@/libs/ws/generalService";
import { formulaService } from "@/libs/ws/formulaService";
import { productionOrderService } from "@/libs/ws/productionOrderService";
import ConstantSections from "@/constants/sections";
import { employeesService } from "../../../libs/ws/employeesService";
import ProductionOrderStates from "@/constants/productionStates";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      creation_date_menu: false,
      scheduled_date_menu: false,
      estimated_end_date_menu: false,
      formulas: [],
      statuses: [],
      warehouses: [],
      lines_production: [],
      internal_states: [],
      users: [],
    };
  },
  computed: {
    isInExecution() {
      return this.item && this.item.status && this.item.status.id === ProductionOrderStates.STATE_IN_EXECUTION;
    },
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog(val) {
      if (val) {
        this.errors.clear();
        this.loadComboData();
      }
    },
  },
  mounted() {
    this.loadEmployees();
    this.loadComboData();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    calculateQuantityProductFinal() {
      if (this.item && this.item.formula && this.item.formula.amount_result && this.item.quantity) {
        const quantity = parseFloat(this.item.quantity);
        const amountResult = parseFloat(this.item.formula.amount_result);
        if (!isNaN(quantity) && !isNaN(amountResult)) {
          this.item.quantity_product_final = (quantity * amountResult).toFixed(2);
        } else {
          this.item.quantity_product_final = null;
        }
      } else {
        this.item.quantity_product_final = null;
      }
    },

    loadComboData() {
      // Cargar fórmulas
      generalService.setSection(ConstantSections.SECTION_FORMULAS);
      generalService
        .filter()
        .then((response) => {
          this.formulas = response.result;
        })
        .catch((e) => {
          console.log("formulas.filter error", e);
        });

      // Cargar almacenes
      generalService.setSection(ConstantSections.SECTION_WAREHOUSES);
      generalService
        .filter()
        .then((response) => {
          this.warehouses = response.result;
          
          // Si solo hay un almacén, autoseleccionarlo en origen y destino
          if (this.warehouses.length === 1 && !this.item.id) {
            this.item.warehouse_origen = this.warehouses[0];
            this.item.warehouse_destino = this.warehouses[0];
          }
        })
        .catch((e) => {
          console.log("warehouses.filter error", e);
        });

      // Cargar líneas de producción
      generalService.setSection(ConstantSections.SECTION_PRODUCTION_LINES);
      generalService
        .filter()
        .then((response) => {
          this.lines_production = response.result;
          
          // Si solo hay una línea de producción, autoseleccionarla
          if (this.lines_production.length === 1 && !this.item.id) {
            this.item.line_production = this.lines_production[0];
          }
        })
        .catch((e) => {
          console.log("lines_production.filter error", e);
        });

      // Cargar estados internos
      generalService.setSection(ConstantSections.SECTION_INTERNAL_STATES);
      generalService
        .filter()
        .then((response) => {
          this.internal_states = response.result;
        })
        .catch((e) => {
          console.log("internal_states.filter error", e);
        });

    },
    loadEmployees(){
      employeesService
        .filter()
        .then((response) => {
          this.users = response.result;
        })
        .catch((e) => {
          console.log("employees.filter error", e);
        });
    },  
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;
          
          const data = {
            id: this.item.id,
            creation_date: this.item.creation_date,
            scheduled_date: this.item.scheduled_date,
            estimated_end_date: this.item.estimated_end_date,
            quantity: this.item.quantity,
            quantity_product_final: this.item.quantity_product_final,
            external_reference: this.item.external_reference,
            observations: this.item.observations,
            formula: this.item.formula,
            warehouse_origen: this.item.warehouse_origen,
            warehouse_destino: this.item.warehouse_destino,
            line_production: this.item.line_production,
            internal_state: this.item.internal_state,
            user_assignated: this.item.user_assignated,
          };

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se modificó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          } else {
            this.service
              .create(data)
              .then((response) => {
                if (response.result.id > 0) {
                  this.$toast.success("La " + this.modal_title + " se creó correctamente", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        }
      });
    },
  },
};
</script>
